import React from "react";
import { object, number } from "prop-types";

import StoryHeader from "../story-header";
import StoryElements from "../story-elements";
import StorySideBar from "../story-sidebar";

import "./podcast.m.css";

import StorySeparator from "../../atoms/story-separator";
import useDevice from "../../helper/custom-hook/useDevice";

const PodCastStoryTemplate = ({ story, index }) => {
  const isMobile = useDevice();
  return (
    <>
      {index > 0 && <StorySeparator />}
      <div styleName="story-wrapper">
        <div className="story-section">
          <div>
            <StoryHeader story={story} isPodCast showHeroImage={false} />
            <StoryElements story={story} cards={story.cards} index={index} isPodcast />
          </div>
        </div>
        {!isMobile && (
          <div className="side-story-section ">
            <StorySideBar index={index} story={story} />
          </div>
        )}
      </div>
    </>
  );
};

PodCastStoryTemplate.propTypes = {
  story: object,
  index: number
};

const PodCastStory = (props) => {
  return <PodCastStoryTemplate story={props.story} index={props.index} />;
};

PodCastStory.propTypes = {
  story: object,
  index: number
};

export default PodCastStory;
